module.exports = __webpack_public_path__ + "img/percent-03.b03c8c51.svg";